import { ENTITY_TYPE } from './types';

import { PlatformName } from '@/features/users';

export const PLATFORM_ENTITY_TYPES: Record<
  PlatformName,
  { campaign: ENTITY_TYPE; adUnit: ENTITY_TYPE; insertionOrder?: ENTITY_TYPE }
> = {
  'The Trade Desk': {
    campaign: ENTITY_TYPE.CAMPAIGN,
    adUnit: ENTITY_TYPE.ADGROUP,
  },
  Meta: {
    campaign: ENTITY_TYPE.META_CAMPAIGN,
    adUnit: ENTITY_TYPE.ADSET,
  },
  DV360: {
    campaign: ENTITY_TYPE.CAMPAIGN,
    adUnit: ENTITY_TYPE.ADGROUP,
    insertionOrder: ENTITY_TYPE.INSERTION_ORDER,
  },
  TikTok: {
    campaign: ENTITY_TYPE.CAMPAIGN,
    adUnit: ENTITY_TYPE.ADGROUP,
  },
};
